import React from 'react'
import SupportMentorsListing from 'src/supportPortal/components/common/mentor/listing/SupportMentorsListing'
import { MENTOR_MENU_ITEMS } from 'src/supportPortal/components/common/mentor/listing/utils'

export default function DoctorsListing() {
  return (
    <SupportMentorsListing
      mentorsListApiSignature="/api/secure/cc/support/doctor/list"
      heading="Doctors"
      exculudeMenuItemsList={[
        MENTOR_MENU_ITEMS.CALENDAR.id,
        MENTOR_MENU_ITEMS.NEXT_VISITS.id,
        MENTOR_MENU_ITEMS.ENGAGEMENT_MODELS.id,
      ]}
    />
  )
}
